var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024.003",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M776.28 483.905L303.435 11.062c-15.654-15.118-40.598-14.684-55.716.97-14.75 15.27-14.75 39.478 0 54.746l444.985 444.985L247.72 956.748c-15.384 15.386-15.384 40.33 0 55.716 15.388 15.384 40.33 15.384 55.716 0L776.28 539.62c15.383-15.387 15.383-40.33 0-55.715z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.9c87fd9cd813af8d4c7193c796b5e1be.svg";
export { ForwardRef as ReactComponent };